module.exports = __webpack_public_path__ + "static/img/PortFoliopremium.12f23ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PortFoliopremium.svg
// module id = DQQ1
// module chunks = 1